import { render, staticRenderFns } from "./SectionMenuBilling.vue?vue&type=template&id=08763a34&scoped=true&"
import script from "./SectionMenuBilling.vue?vue&type=script&lang=js&"
export * from "./SectionMenuBilling.vue?vue&type=script&lang=js&"
import style0 from "./SectionMenuBilling.vue?vue&type=style&index=0&id=08763a34&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08763a34",
  null
  
)

export default component.exports